(function () {
  'use strict';

  function initServiceChips(container) {
    if (!container || container.dataset.serviceChipsInited === 'true') return;
    var hiddenInput = container.querySelector('input[type="hidden"][name="contact[Service Interest]"]');
    var checkboxes = container.querySelectorAll('input[type="checkbox"][data-service-chip]');
    if (!hiddenInput || !checkboxes.length) return;

    function updateHidden() {
      var values = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked && cb.value) values.push(cb.value);
      });
      hiddenInput.value = values.join(', ');
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', updateHidden);
    });
    updateHidden();
    container.dataset.serviceChipsInited = 'true';
  }

  function init() {
    document.querySelectorAll('[data-service-chips]').forEach(initServiceChips);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector) section.querySelectorAll('[data-service-chips]').forEach(initServiceChips);
  });
})();
